<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <br><br>
    <div-time-table v-if="show_tt==true" :curr_lid="this.curr_lid" :div_id="this.div_off_id"></div-time-table>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import DivTimeTable from "@/components/TimeTable/DivTimeTable"
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
//import DivTimeTable from '../TimeTable/DivTimeTable'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
     name: "DivTimeTable",
components:{
  'div-time-table': DivTimeTable,
  Breadcrumbs
},
   data: () => ({
        show_tt:false,
        child_data:null,
        div_off_id:null,
     curr_lid: null,
    //  extraBreadcrumbItems: [


    //  ],
    //  breadcrumbClass: "breadcrumb-style1",
  }),
  methods: {
      onload(){
       // this.show_tt=false
       axios
      .post("/commonAPI/getLearnerData")
      .then(res => {
        if (res.data.msg == "200") {
          if ((res.data.status = "SUCCESS")) {
              //alert("then")
           this.show_tt=true
           this.child_data = res.data.child_data
           this.div_off_id=res.data.child_data[0].div_off_id,
           this.curr_lid=res.data.child_data[0].lid
           return
          } else {
            alert(res.data.status_reason);
          }
        }
      })
      .catch(error => {
        window.console.log(error);
      })
      .finally(() => {
        //close loader
        //this.loader = false;
        //alert("done")
      });
    // axios
    //     .post("/commonAPI/getLearnerData")
    //     .then(res => {
    //     if (res.data.msg == "200") {
    //       if (res.data.status == "SUCCESS") {
    //           alert("then")
    //        this.show_tt=true
    //        this.child_data = res.data.child_data
    //        this.div_off_id=res.data.child_data.div_off_id,
    //        this.curr_lid=res.data.child_data.lid
    //        return
    //       }
    //     }
    //     })
    //     .catch(error => {
    //       alert("Somthing went wrong!!!");
    //     })
    //     .finally(() => {
    //         //stop loader 
    //     });
      },
  },
   mounted() {
       this.onload();
  },
  watch: {},
};
</script>
<style scoped>


</style>
